import { i18n } from "translations";

export enum ExampleType {
  foo = 1,
  bar = 3,
}

export enum Status {
  Active = 1,
  Inactive = 3,
}

export const StatusOptions = [
  { label: i18n.t("active"), value: Status.Active },
  { label: i18n.t("inactive"), value: Status.Inactive },
];
